"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateSubMenu = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
const stateSubMenu = exports.stateSubMenu = [{
  path: '/states/list',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/state/list.vue'))),
  name: 'States',
  meta: {
    title: 'stateManagement.states.title',
    noCache: true,
    icon: 'list',
    activeMenu: '/states/list',
    roles: ['System Admin', 'Super Admin']
  }
}, {
  path: '/states/add',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/state/manage.vue'))),
  name: 'AddState',
  props: {
    isEdit: false
  },
  meta: {
    title: 'stateManagement.states.manage',
    noCache: true,
    activeMenu: '/states/list',
    hidden: true
  }
}, {
  path: '/states/edit/:id(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/state/manage.vue'))),
  name: 'EditState',
  props: {
    isEdit: true
  },
  meta: {
    title: 'stateManagement.states.manage',
    noCache: true,
    activeMenu: '/states/list',
    hidden: true
  }
}];